var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownMarketOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FD6D00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0003,
    cy: 15.9999,
    r: 12.2353,
    fill: "url(#paint0_linear_1756_7894)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1756_7894)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8818 21.7645C18.991 21.7645 19.0957 21.7211 19.1729 21.6439C19.2502 21.5667 19.2935 21.462 19.2935 21.3528V11.6409L21.8844 14.2325C21.9617 14.3098 22.0666 14.3533 22.1759 14.3533C22.2852 14.3533 22.3901 14.3098 22.4674 14.2325C22.5447 14.1552 22.5882 14.0503 22.5882 13.941C22.5882 13.8316 22.5447 13.7268 22.4674 13.6495L19.1733 10.3553C19.1351 10.317 19.0896 10.2866 19.0396 10.2658C18.9896 10.2451 18.9359 10.2344 18.8818 10.2344C18.8276 10.2344 18.774 10.2451 18.724 10.2658C18.6739 10.2866 18.6285 10.317 18.5903 10.3553L15.2961 13.6495C15.2188 13.7268 15.1754 13.8316 15.1754 13.941C15.1754 14.0503 15.2188 14.1552 15.2961 14.2325C15.3735 14.3098 15.4783 14.3533 15.5877 14.3533C15.697 14.3533 15.8019 14.3098 15.8792 14.2325L18.47 11.6409V21.3528C18.47 21.462 18.5134 21.5667 18.5906 21.6439C18.6678 21.7211 18.7726 21.7645 18.8818 21.7645ZM13.1171 10.2351C13.2263 10.2351 13.331 10.2785 13.4082 10.3557C13.4855 10.4329 13.5288 10.5377 13.5288 10.6469V20.3588L16.1197 17.7671C16.197 17.6898 16.3019 17.6464 16.4112 17.6464C16.5205 17.6464 16.6254 17.6898 16.7027 17.7671C16.78 17.8444 16.8235 17.9493 16.8235 18.0586C16.8235 18.168 16.78 18.2729 16.7027 18.3502L13.4086 21.6443C13.3704 21.6826 13.3249 21.7131 13.2749 21.7338C13.2249 21.7546 13.1712 21.7653 13.1171 21.7653C13.0629 21.7653 13.0093 21.7546 12.9593 21.7338C12.9092 21.7131 12.8638 21.6826 12.8255 21.6443L9.53143 18.3502C9.45411 18.2729 9.41068 18.168 9.41068 18.0586C9.41068 17.9493 9.45411 17.8444 9.53143 17.7671C9.60875 17.6898 9.71362 17.6464 9.82296 17.6464C9.9323 17.6464 10.0372 17.6898 10.1145 17.7671L12.7053 20.3588V10.6469C12.7053 10.5377 12.7487 10.4329 12.8259 10.3557C12.9031 10.2785 13.0079 10.2351 13.1171 10.2351Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1756_7894",
    x1: 16.0003,
    y1: 3.76465,
    x2: 16.0003,
    y2: 28.2352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D76107"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1756_7894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.1765,
    height: 13.1765,
    fill: "white",
    transform: "translate(9.41147 9.41113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownMarketOrderIcon);
export default __webpack_public_path__ + "static/media/arrow-down-market-order-icon.22e1aae2bdbf3550abc99a3f4d0c4e7c.svg";
export { ForwardRef as ReactComponent };